<template>
	<v-layout v-if="!dataSame && contestId">
		<v-flex xs6>
			<old-version-marker/>
			<choose-d-a-c
				:contest-id="contestId"
				:type="isAgency ? 'AGENCY_CONTEST' : 'PUBLIC_CONTEST'"
				v-model="old"
				:readonly="true"
			></choose-d-a-c>
		</v-flex>
		<v-flex xs6>
			<new-version-marker/>
			<choose-d-a-c
				:contest-id="contestId"
				:type="isAgency ? 'AGENCY_CONTEST' : 'PUBLIC_CONTEST'"
				v-model="current"
				:readonly="true"
			></choose-d-a-c>
		</v-flex>
	</v-layout>
</template>

<script>
	import OldVersionMarker from "./oldVersionMarker";
	import NewVersionMarker from "./NewVersionMarker";
	import ChooseDAC from "../components/ChooseDAC";

	export default {
		name: "CompareDacCodes",
		components: {ChooseDAC, NewVersionMarker, OldVersionMarker},
		computed: {
			dataSame () {
				let comparisonResult = JSON.stringify(this.old) === JSON.stringify(this.current);
				if (comparisonResult === false) {
					this.$emit('dataDiffer', true);
				}
				return comparisonResult;
			}
		},

		props: {
			old: {},
			current: {},
			contestId: {},
			isAgency: {}
		}
	};
</script>

<style scoped>

</style>
